import React from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import "../../Assets/Styles/Auth.scss";
import Login from "../Auth/Login";
import ResetPassword from "../Auth/ResetPassword";
import Vector from "../../Assets/Images/Auth.svg";
import DisabledVector from "../../Assets/Images/DisabledAccount.svg";

const Auth = () => {
  return (
    <BrowserRouter basename="/">
      <div className="auth">
        <div className="column banner-area is-two-fifths-desktop">
          <img
            alt="Login to connexing"
            className="login-vector"
            id="auth-vector"
            src={Vector}
          />
          <img
            alt="Account disabled!"
            id="auth-disabled"
            src={DisabledVector}
          />
        </div>
        <div className="column auth-form-area is-three-fifths-desktop">
          <Switch>
            <Route path="/Redirect/:Token" component={Login} />
            <Route path="/" component={Login} />
            <Route path="/ResetPassword" exact component={ResetPassword} />
          </Switch>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default Auth;
